import React from 'react';
import { node, string } from 'prop-types';
import Widget from '../Widget';

const IconWithTextCard = ({ icon, title, subTitle }) => (
  <Widget>
    <div className="gx-media gx-align-items-center gx-flex-nowrap">
      <div className="gx-mr-lg-4 gx-mr-3">{icon}</div>
      <div className="gx-media-body">
        <h1 className="gx-fs-xxxl gx-font-weight-medium gx-mb-1">{title}</h1>
        <p className="gx-text-grey gx-mb-0">{subTitle}</p>
      </div>
    </div>
  </Widget>
);

IconWithTextCard.propTypes = {
  icon: node.isRequired,
  title: node.isRequired,
  subTitle: string.isRequired,
};

export default IconWithTextCard;
